module.exports = __webpack_public_path__ + "static/media/screenshot2.99487e35.png";